export default __webpack_public_path__ + "static/media/add-symbol.b86db3b4.svg";